import { ApiEndpoints } from "@shared/api/api-endpoints";
import {
  cxApiClient,
  onboardingApiClient,
} from "@shared/api/clients/apiClientFactory";
export const facilityApi = {
  getFacitlity: async (params: {
    remote_utility_id: string;
    config_level: string;
    show_inactive: string;
  }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "onboarding",
      "config-map/facility_type",
      (qs) => {
        qs.push("remote_utility_id", params.remote_utility_id);
        qs.push("config_level", params.config_level);
        qs.push("show_inactive", params.show_inactive);
      }
    );
    const response = await onboardingApiClient.get(url);
    return response.data;
  },

  addFacility: async (payload: any): Promise<any> => {
    const url = ApiEndpoints.createUrl(
      "onboarding",
      "config-map/facility_type"
    );
    const response = await cxApiClient.post(url, payload);
    return response.data;
  },

  updateFacility: async (payload: any): Promise<any> => {
    const url = ApiEndpoints.createUrl(
      "onboarding",
      "config-map/facility_type"
    );
    const response = await cxApiClient.patch(url, payload);
    return response.data;
  },

  searchFacilityType: async (params: {
    remote_utility_id: string | number;
    search_data: string;
    search_field?: string;
  }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "onboarding",
      "search/onboarding_config",
      (qs) => {
        qs.push("remote_utility_id", params.remote_utility_id.toString());
        qs.push("search_field", params.search_field);
        qs.push("search_data", params.search_data);
      }
    );
    const response = await onboardingApiClient.get(url);
    return response.data;
  },
    deleteFacility: async (params: {
      remote_utility_id: string;
      code: string;
    }): Promise<any> => {
      const url = ApiEndpoints.createUrlWithQueryParameters(
        "onboarding",
        `config-map/facility_type`,
        (qs) => {
          qs.push("remote_utility_id", params.remote_utility_id);
          qs.push("code", params.code);
        }
      );
      const response = await onboardingApiClient.delete(url);
      return response.data;
    },
};
